import React from "react";

export default function Layout({ children }) {
  return (
    <main className="font-main max-w-screen-2xl mx-auto overflow-x-hidden">
      {children}
    </main>
  );
}
